import styled, { css } from 'styled-components'
import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Container = styled.div`
    position: relative;
    padding-bottom: 80px;

    width: 100%;
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;
    text-align: center;

    overflow: hidden;

    > * + * {
        margin-top: 50px;
    }
`

export const Content = styled.div`
    max-width: 1110px;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0 auto;
`

export const BenefitsWrapper = styled.div`
    padding-top: 100px;
    display: grid;
    column-gap: 20px;
    row-gap: 60px;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto;
    grid-template-areas:
        'item-1 image item-0'
        'item-2 image item-3'
        'item-5 image item-4';

    ${mobile(`
        padding: 20px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto auto auto;
        grid-template-areas: none;
        row-gap: 20px;
    `)}
`

export const BenefitContainer = styled.div`
    grid-area: item-${(p) => p.$index};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: ${(p) => (p.$pos === 'left' ? 'row-reverse' : 'row')};
    text-align: ${(p) => (p.$pos === 'left' ? 'right' : 'left')};
    max-width: 240px;
    column-gap: 10px;
    margin-top: ${(p) => (p.$pos === 'left' ? 20 : -20)}px;
    transform: translateX(
        ${(p) =>
            ![2, 3].includes(p.$index)
                ? p.$pos === 'right'
                    ? '-30px'
                    : '30px'
                : 0}
    );

    img {
        width: 60px;
        height: 60px;
    }

    div {
        display: flex;
        flex-direction: column;
    }

    ${mobile(css`
        grid-area: auto;
        max-width: 100%;
        transform: none;
        margin: 0;
        flex-direction: column;
        gap: 10px;
        row-gap: 15px;
        text-align: center;
        justify-content: flex-start;
    `)}
`

export const ImageWrapper = styled.div`
    grid-area: image;
    align-self: center;

    img {
        display: block;
        width: 100%;
    }

    ${mobile(`
        grid-area: 1;
        grid-column: span 2;
    `)}
`

export const BenefitTitle = styled.span`
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    color: ${colors.deepPurple};

    ${mobile(`
        font-size: 18px;
    `)}
`

export const BenefitText = styled.span`
    line-height: 22px;
    color: ${colors.gray_50};
`
